<template functional>
  <td
    :class="[
      data.class,
      data.staticClass,
      'ten-date-item', {
        'ten-date-item--active': props.active,
        'ten-date-item--disabled': props.disabled,
        'ten-date-item--highlight': props.highlight,
        'ten-date-item--active-start': props.startOfRange,
        'ten-date-item--active-end': props.endOfRange,
        'ten-date-item--additional': props.additional,
        'ten-date-item--now': props.now,
        'ten-date-item--first-day-of-month': props.firstDayOfMonth,
        'ten-date-item--last-day-of-month': props.lastDayOfMonth
      }
    ]"
  >
    <slot>
      <div
        class="ten-date-item__wrapper"
        @click="function() {
          if (!props.disabled) {
            props.onClick(props.value)
          }
        }"
        @mouseenter="function() {
          props.onMouseEnter(props.value);
        }"
      >
        <span class="ten-date-item__text">{{ props.text }}</span>
      </div>
    </slot>
  </td>
</template>

<script>
export default {
  props: {
    text: [String, Number],
    value: Date,
    active: Boolean,
    highlight: Boolean,
    disabled: Boolean,
    startOfRange: Boolean,
    endOfRange: Boolean,
    additional: Boolean,
    now: Boolean,
    onClick: Function,
    onMouseEnter: { type: Function, default: () => {} },
  },
};
</script>
